import React from 'react'
import { searchOfficers } from '../../services/users';
import CustomAsyncSelect from './CustomAsyncSelect';

const OfficerSelect = ({ name, control, rules}) => {

    const loadOfficers = async (inputValue) => {
        if (inputValue.length < 3) {
            return [];
        }

        try {
             const officers = await searchOfficers(inputValue);
             return officers.data.map((officer) => ({label: officer.name, value: officer.id, ...officer}));
        } catch (error) {
            return [];
        }
    }
  return (
    <CustomAsyncSelect
        name={name}
        control={control}
        loadOptions={loadOfficers}
        rules={rules}
        placeholder='Search for a security officer...'
    />
  )
}

export default OfficerSelect